module.exports = __webpack_public_path__ + "static/media/footerLogo.f08fc002.svg";